import React from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";

const NoPageFound = () => {
  const error404 =
    "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/404.png";
  return (
    <div className="no-page-wrapper">
      <img src={error404} alt="Page not found" className="error-img" />
      <p className="go-to-text">
        Go back to{" "}
        <Link to={PATHS.HOME} className="previous-page">
          Previous Page
        </Link>
      </p>
    </div>
  );
};

export default NoPageFound;
